/**
 * Manage, Campaigns (plan docs/plans/lms-plan.md 8.2 "the campaign list shows
 * past sends with their counts and a per-person outcome table", 5.4, 18.21;
 * plan section 13 tab 7; WP-43; R6, R8, G9).
 *
 * Replaces WP-03's placeholder in place: tabs/manage/subviews.ts imports this
 * file's DEFAULT export (a component with no props), mounted at
 * /lms/manage/campaigns/* (plan 18.3), so it routes its own deeper paths:
 *
 *   /lms/manage/campaigns                 the send history (CampaignList)
 *   /lms/manage/campaigns/:campaignId     one send, person by person (CampaignDetailPage)
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import CampaignDetailPage from './CampaignDetailPage';
import CampaignList from './CampaignList';
import { CAMPAIGNS_BASE } from './labels';

export function CampaignsView() {
  return (
    <Routes>
      <Route index element={<CampaignList />} />
      <Route path=":campaignId" element={<CampaignDetailPage />} />
      <Route path="*" element={<Navigate to={CAMPAIGNS_BASE} replace />} />
    </Routes>
  );
}

export default CampaignsView;
